import Vue from 'vue'
import VueRouter from 'vue-router'
import Guard from "../Helpers/guards";

Vue.use(VueRouter)

import Signin from '../components/User/signin'
import SignUp from '../components/User/signup'
import Logout from '../components/User/logout'
import Profile from '../components/User/profile'
// import Home from '../components/Home/home'
import Main from '../components/Devices/main'
import New from '../components/Devices/new'
import Device from '../components/Devices/device'
// import Item from '../components/Home/item'
import Settings from '../components/Settings/settings'
import Logs from '../components/Logs/create'
import Notifications from '../components/User/notifications'
import Offline from '../components/General/offline'

const routes = [{
        path: '/login',
        component: Signin,
        beforeEnter: Guard.guest
    },
    {
        path: '/signup',
        component: SignUp,
        beforeEnter: Guard.guest
    },
    {
        path: '/',
        component: Main,
        beforeEnter: Guard.user,
        children: [
          {
            path: 'item/:slug',
            component: Device
          }
        ]
    },
    {
        path: '/new',
        component: New,
        beforeEnter: Guard.user
    },
    {
        path: '/profile',
        component: Profile,
        beforeEnter: Guard.user
    },
    {
        path: '/logout',
        component: Logout,
        beforeEnter: Guard.user
    },
    {
        path: '/logs',
        component: Logs,
        beforeEnter: Guard.user
    },
    {
        path: '/profile/Settings',
        component: Settings,
        beforeEnter: Guard.user
    },
    {
        path: '/profile/notifications',
        component: Notifications,
        beforeEnter: Guard.user
    },
    {
        path: '/offline',
        component: Offline,
    },
]

const router = new VueRouter({
    routes,
    hasbang: false,
    mode: 'history'
})

export default router
